import React, { useState } from "react";

export default function Checkbox({
  theme,
  id,
  className,
  label,
  isFocus,
  isEnabled,
  isChecked,
  onClick = () => {},
}) {
  const [hasFocus, setHasFocus] = useState(false);

  const checkboxItem = () => {
    let css = "";
    const tick = theme === "light" ? "bg-white-tick" : "bg-dark-tick";
    css += ` group-hover:bg-${theme}-btn-hover `;
    if (isFocus || hasFocus) {
      css += ` border-${theme}-on-focus border-thin  ${isChecked} `;
      if (isChecked) {
        css += ` ${tick} bg-cover bg-${theme}-input-focus bg-opacity-80`;
      }
    } else {
      const borderColor = isEnabled
        ? ` border-${theme}-checkbox-enabled `
        : ` border-${theme}-checkbox-disabled `;
      const bgColor = isEnabled
        ? ` bg-${theme}-checkbox-enabled `
        : ` bg-${theme}-checkbox-disabled `;
      css += ` ${theme !== "light" && "border-thin"} ${borderColor}  `;
      if (isChecked) {
        css += ` ${tick} bg-cover bg-${theme}-checked `;
      } else {
        css += ` border-thin `;
      }
    }
    return css;
  };

  const handleClick = (e) => {
    e.stopPropagation();
    if (isEnabled) onClick(id); // ✅ 禁止 disabled 狀態下觸發
  };

  return (
    <div
      id={id}
      tabIndex={isEnabled ? 0 : -1}
      aria-disabled={!isEnabled} // ✅ 輔助功能支援
      data-disabled={!isEnabled}
      onClick={handleClick}
      role="checkbox"
      aria-label={label}
      aria-checked={isChecked}
      onFocus={() => isEnabled && setHasFocus(true)}
      onBlur={() => isEnabled && setHasFocus(false)}
      className={`flex cursor-pointer group ` + className}
    >
      <div
        aria-hidden={"true"}
        aria-label={label}
        aria-roledescription={"checkbox"}
        className={`rounded-md w-7 h-7 mr-3 justify-center items-center 
            ${checkboxItem()}`}
      />
      <label
        className={`cursor-pointer text align-middle ${
          isEnabled
            ? `text-${theme}-normal`
            : `text-${theme}-normal opacity-70`
        }`}
        form="scales"
        aria-label={label}
        aria-roledescription={"input"}
        aria-hidden={"true"}
      >
        {label}
      </label>
    </div>
  );
}
